import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Dropdown, MenuItem } from 'react-bootstrap';
import enhanceWithClickOutside from 'react-click-outside';

const periods = [
  {
    value: 'monthly',
    label: 'Monthly',
  },
  {
    value: 'annual',
    label: 'Annual',
  },
];

class PeriodDropdown extends Component {
  constructor() {
    super();
    this.state = {
      dropdownOpen: false,
    };
    this.handleToggle = this.handleToggle.bind(this);
    this.handleClickOutside = this.handleClickOutside.bind(this);
    this.handleTogglePeriodItem = this.handleTogglePeriodItem.bind(this);
  }

  handleToggle(dropdownOpen) {
    this.setState({ dropdownOpen });
  }

  handleClickOutside() {
    this.setState({ dropdownOpen: false });
  }

  handleTogglePeriodItem(period) {
    this.setState({ dropdownOpen: false });
    this.props.handlePeriodChange(period.value);
  }

  render() {
    const { dropdownOpen } = this.state;
    const { period } = this.props;
    const selected = periods.find(p => p.value === period);
    const dropdownPeriodLabel = selected ? selected.label : 'Select a period';

    return (
      <Dropdown
        id="period-dropdown"
        onToggle={this.handleToggle}
        open={dropdownOpen}
      >
        <Dropdown.Toggle bsSize="small">
          <span>{dropdownPeriodLabel}</span>
        </Dropdown.Toggle>
        <Dropdown.Menu>
          {periods.map(p => (
            <MenuItem
              active={period === p.value}
              key={p.value}
              onSelect={() => this.handleTogglePeriodItem(p)}
            >
              {p.label}
            </MenuItem>
          ))}
        </Dropdown.Menu>
      </Dropdown>
    );
  }
}

PeriodDropdown.propTypes = {
  handlePeriodChange: PropTypes.func,
  period: PropTypes.string,
};

PeriodDropdown.defaultProps = {
  period: 'monthly',
  handlePeriodChange: () => {},
};

export default enhanceWithClickOutside(PeriodDropdown);
